import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Linkedin = ({ ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    <path
      d='M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19ZM5.75781 18.5H8.44238V9.83301H5.75781V18.5ZM15.3457 9.56836C13.5066 9.56836 12.7324 11.001 12.7324 11.001V9.83301H10.1582V18.5H12.7324V13.9502C12.7325 12.7314 13.2942 12.0059 14.3682 12.0059C15.355 12.0061 15.829 12.7033 15.8291 13.9502V18.5H18.5V13.0127C18.5 10.6911 17.1839 9.56839 15.3457 9.56836ZM7.08691 5.5C6.21029 5.50023 5.5 6.21659 5.5 7.09961C5.50019 7.98247 6.2104 8.69801 7.08691 8.69824C7.96362 8.69824 8.67364 7.98261 8.67383 7.09961C8.67383 6.21645 7.96374 5.5 7.08691 5.5Z'
      fill='currentColor'
    />
  </IconBase>
);
